

import { get } from 'svelte/store';
import { sentryHub, SentryErrorType } from "Utils/sentryHelper";

import { amplitudeInit, sendTrack, TrackEvent } from "Utils/AmplitudeHelper";
import { isCriticalError } from "Utils/isCriticalError"

import { isLeftHandedUI, soundVolume } from "Utils/settings"

import { optionsStore, settingsStore, campaingStore, statusStore, extWinStore, coinsInfoStore } from "Store/data.js";

import { createServer } from "./Server.js"

import { createGameService, GameEventType } from 'Core/GameService.js';


import { setupI18n, _, isLocaleLoaded } from "Utils/i18";
import { getSkinJson } from "Utils/getSkin";

import { coinPosition } from "Store/CoinPositionStore.js"




export const APP_STATE = {
    LOADING: "Loading",
    INITED: "Inited",
    CONNECTED: "Connected",
    ERROR: "Error",

}


function createAppController() {

//    const server = createServer(onUpdate, onServerError);


    const gameService = createGameService(onGameStateChanged)



    let isFirstDataUpdate = true;



    function onServerError() {
        
        statusStore.status.set(APP_STATE.ERROR)
    }


    function onUpdate(parsedData) {



        try {
            if (parsedData) {

                campaingStore.addCampaing(parsedData)
                getSkinJson();
            }

            for (let key in parsedData) {

                if (key === 'casino') {
                    campaingStore.addCasino(parsedData.casino)
                }


                if (key === 'playerSubscription') {
                    campaingStore.addUserSubscription(parsedData.playerSubscription)
                }

                if (key === 'conversionRate') {
                    campaingStore.addUserCurrencyRate(parsedData.conversionRate)
                }



                if (key === 'userWinInfo') {
                    //in BigWin popup
                    campaingStore.addWin(parsedData.userWinInfo)
                    //State.addUserWin(parsedData.userWinInfo)
                } else if (key === 'externalWinInfo') {
                    //in small popup
                    //State.addExternalWin(parsedData.externalWinInfo)


                    // extWinStore.addExternalWin(parsedData.externalWinInfo)
                    updateAllData()

                    //				this.updateAllData();//hack

                } else if (key === 'winsInfo') {
                    //in menu (not player)
                    //State.setWinsInfo(parsedData.winsInfo)
                    campaingStore.setWinsInfo(parsedData.winsInfo)

                } else if (key === 'playerWinsInfo') {
                    //in menu (player win)
                    //State.setPlayerWinsInfo(parsedData.playerWinsInfo)
                    campaingStore.setPlayerWinsInfo(parsedData.playerWinsInfo)

                } else if (key === 'coinsInfo') {
                    //State.setCoinsInfo(parsedData.coinsInfo)
                    coinsInfoStore.setCoinsInfo(parsedData.coinsInfo)
                }

            }
        } catch {
            console.error("Error AppController: can't update")
        }

        if (isFirstDataUpdate) {
            isFirstDataUpdate = false
            statusStore.status.set(APP_STATE.CONNECTED)
        }



    }

    function onGameStateChanged(event) {
        if (event.type === GameEventType.READY) {
            statusStore.status.set(APP_STATE.INITED)
        }
        if (event.type === GameEventType.SOUND_CHANGED) {
            soundVolume.set(event.value);
        }

        if (event.type === GameEventType.GAME_UI_OVERLAP) {
            if (event.value) {
                settingsStore.settings.update((value) => ({ ...value, isOverlap: true }))
            } else {
                settingsStore.settings.update((value) => ({ ...value, isOverlap: false }))
            }
            //console.log(`APP_CONTROLLER: overlap`)
            //console.log(get(settingsStore.settings))

        }
		if (event.type === GameEventType.COIN_ENABLED) {
            settingsStore.settings.update((value) => ({...value, isCoinEnabled: true}))
        }
		if (event.type === GameEventType.COIN_DISABLED) {
            settingsStore.settings.update((value) => ({...value, isCoinEnabled: false}))
        }
    }



    function init() {
        initOptions()
        initSettings()
        let options = get(optionsStore.options)

        setupI18n({ withLocale: options.locale }).then(() => {
            gameService.activate(options.isLobbyEnabled)
            //statusStore.status.set(true)
        }).catch((e) => {
            console.error(e)
            //isCriticalError.set(true);
            statusStore.status.set(APP_STATE.ERROR)
        })



    }


    function initOptions() {

        if (!window.__OPTIONS__.currency) {
            sentryHub.captureMessage(
                SentryErrorType.OPTIONS_UNDEFINED + ": currency"
            );
            //isCriticalError.set(true);
            statusStore.status.set(APP_STATE.ERROR)
        }







        // amplitudeInit(window.__OPTIONS__.loyalty_system_options.player_id, window.__OPTIONS__.identifier);
        sendTrack(TrackEvent.AppInit);

        if (!window.__OPTIONS__.currency) {
            sentryHub.captureMessage("__OPTIONS__.currency is undefined ");
        }

        if (!window.__OPTIONS__.locale) {
            sentryHub.captureMessage(SentryErrorType.OPTIONS_UNDEFINED + ": locale");
            isCriticalError.set(true);
        }


        if (!window.__OPTIONS__.loyalty_system_options) {
            isCriticalError.set(true);
        }

        if (!window.__OPTIONS__.loyalty_system_options.hasOwnProperty(
            "currency_exponent"
        )) {
            sentryHub.captureMessage(SentryErrorType.OPTIONS_UNDEFINED + ": currency_exponent");
            isCriticalError.set(true);
        }


        let currencyAlias = window.__OPTIONS__.currency
        if (currencyAlias === "LYSC"){
            currencyAlias = "SC"
        }

        optionsStore.options.set({
            currency: currencyAlias,
            locale: window.__OPTIONS__.locale,
            exponent: window.__OPTIONS__.loyalty_system_options.currency_exponent,
            userId: window.__OPTIONS__.loyalty_system_options.player_id,
            wsUrl: window.__OPTIONS__.websocket_url,
            isLobbyEnabled: !!window.__OPTIONS__?.lobby_options?.fe_lobby_app_enabled,
            isGameListEnabled: !!window.__OPTIONS__?.lobby_options?.show_game_list,
        })


        //console.info("optionsStore.options")
        //console.info(get(optionsStore.options))





    }


    //data from game [sound, leftright]
    function initSettings() {
        window.addEventListener("resize", onWindowResize);
        onWindowResize();
    }

    function onWindowResize() {
        const isPortrait = window.innerHeight > window.innerWidth;
        // let gameScale = isPortrait
        //     ? window.innerWidth / 1080
        //     : window.innerWidth / 1920;
        let gameScale = isPortrait
            ? Math.min(window.innerHeight / 1920, window.innerWidth / 1080, 1)
            : Math.min(window.innerHeight / 1080, window.innerWidth / 1920, 1);

        document.documentElement.style.setProperty("--game-scale", gameScale);

        let fontScale = Math.min(0.46 * window.innerHeight / 1024, 0.9 * window.innerWidth / 1024, 1);

        let left, top, w, h
        if (isPortrait) {
            // w = Math.min(window.innerWidth, 1080 * gameScale)
            // h = Math.min(window.innerHeight, 1920 * gameScale)
            w = window.innerWidth
            h = window.innerHeight
        } else {
            w = 1920 * gameScale
            h = 1080 * gameScale
        }


        //TODO: save position here


        let newSettings = {
            fontScale: fontScale,
            gameScale: gameScale,
            orientation: isPortrait ? "portrait" : "landscape",
            left: left,
            top: top,
            w: w,
            h: h
        }

        let settings = get(settingsStore.settings)



        settingsStore.settings.set({ ...settings, ...newSettings })



        coinPosition.clear()


        document.documentElement.style.setProperty("--font-scale", fontScale);
    }



    function connect() {

        //server = createServer(onUpdate);
        let options = get(optionsStore.options)
        server.connect(options.wsUrl)

    }

    function disconnect() {
        //server.disconnect()
    }

    function updateAllData() {
        //server.updateAllData()
    }

    function subscribeToCampaign() {
        //server.subscribeToCampaign()
    }


    return { init, connect, disconnect, updateAllData, subscribeToCampaign }
}


export const appController = createAppController()
